module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_28.8a2dca78.png";